import { reportError } from './ErrorReporter';

export const DOCUMENT_UPLOAD_FAILURE_MESSAGE =
    'ERROR: Failed to upload document(s). Please try again';

export const DOCUMENT_UPLOAD_TOO_LARGE_MESSAGE =
    'Upload too large. Please upload fewer files at a time or reduce file sizes.';

/**
 * Reports a failed document upload to ErrorReporter.
 * Used by Case.onFilesSelectedForUpload for network and HTTP failures.
 */
export async function reportDocumentUploadFailure({
    error,
    caseId,
    fileCount,
    fileNames,
    status,
    responseBody,
}) {
    const err = error instanceof Error ? error : new Error(String(error));
    const additionalData = {
        caseId,
        fileCount,
        fileNames,
    };
    if (status !== undefined) {
        additionalData.status = status;
    }
    if (responseBody !== undefined) {
        additionalData.responseBody = responseBody;
    }
    await reportError(err, 'Case.onFilesSelectedForUpload', additionalData);
}
